import { useSessionStore } from "@/plugins/store";
import { ApiHeaders } from "@esenda/core-ui/interfaces";

export const getCommonHeaderParams = (): ApiHeaders => {
    const sessionStore = useSessionStore();
    return {
        sessionId: sessionStore.sessionId,
        language: sessionStore.language,
    };
};
